import React, { useState } from "react";

const HomeForm = ({
  formName = "Mass Tort Intake – Initial Review",
  brandName = "Sokolove Law",
  websiteName = "Main Website",
}) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    birthState: "",
    birthDate: "",
    story: "",

    // 🔥 eliminator questions
    hasDiagnosis: "",
    exposureTimeframe: "",
    hasAttorney: "",
  });

  const usStates = [
    "Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut",
    "Delaware","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa",
    "Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan",
    "Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada",
    "New Hampshire","New Jersey","New Mexico","New York","North Carolina",
    "North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island",
    "South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont",
    "Virginia","Washington","West Virginia","Wisconsin","Wyoming",
  ];

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const pageUrl = window.location.href;

      const payload = {
        countryName: "USA",
        brandName,
        websiteName,
        formname: formName,
        data: {
          ...form,
          fullName: `${form.firstName} ${form.lastName}`.trim(),
          pageUrl,
        },
      };

      const res = await fetch(
        "https://crm-internal-backend-ayb9fqawg8b6bjen.canadacentral-01.azurewebsites.net/api/submitformdata/retell",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await res.json();
      if (!res.ok) throw new Error(result.message || "Submission failed");

      setMessage("✅ Thank you! We are calling you now.");

      setForm({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        birthState: "",
        birthDate: "",
        story: "",
        hasDiagnosis: "",
        exposureTimeframe: "",
        hasAttorney: "",
      });
    } catch (err) {
      console.error(err);
      setMessage("❌ Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full flex justify-center px-4 sm:px-6 lg:px-8 mt-10 lg:mt-0">
      <div className="bg-[#F9F7F7] rounded-2xl shadow-lg p-6 sm:p-8 lg:p-10 w-full max-w-lg text-[#112D4E]">
        <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-center lg:text-left">
          Start a Free Case Review
        </h2>

        <form className="space-y-4" onSubmit={handleSubmit}>
          {/* Name */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              name="firstName"
              value={form.firstName}
              onChange={handleChange}
              placeholder="First Name"
              required
              className="w-full p-3 rounded-lg bg-[#E6E9F0]"
            />
            <input
              name="lastName"
              value={form.lastName}
              onChange={handleChange}
              placeholder="Last Name"
              required
              className="w-full p-3 rounded-lg bg-[#E6E9F0]"
            />
          </div>

          {/* Contact */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="Phone"
              required
              className="w-full p-3 rounded-lg bg-[#E6E9F0]"
            />
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email"
              required
              className="w-full p-3 rounded-lg bg-[#E6E9F0]"
            />
          </div>

          {/* Diagnosis */}
          <select
            name="hasDiagnosis"
            value={form.hasDiagnosis}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-[#E6E9F0]"
          >
            <option value="">Have you been medically diagnosed?</option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
            <option value="not_sure">Not sure</option>
          </select>

          {/* Exposure timeframe */}
          <select
            name="exposureTimeframe"
            value={form.exposureTimeframe}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-[#E6E9F0]"
          >
            <option value="">When did the exposure or issue occur?</option>
            <option value="within_2_years">Within the last 2 years</option>
            <option value="2_to_5_years">2–5 years ago</option>
            <option value="5_plus_years">More than 5 years ago</option>
            <option value="not_sure">Not sure</option>
          </select>

          {/* Attorney */}
          <select
            name="hasAttorney"
            value={form.hasAttorney}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-[#E6E9F0]"
          >
            <option value="">Are you currently represented by an attorney?</option>
            <option value="no">No</option>
            <option value="yes">Yes</option>
            <option value="not_sure">Not sure</option>
          </select>

          {/* State */}
          <select
            name="birthState"
            value={form.birthState}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-[#E6E9F0]"
          >
            <option value="">Select State</option>
            {usStates.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
          </select>

          {/* DOB */}
          <input
            type="date"
            name="birthDate"
            value={form.birthDate}
            onChange={handleChange}
            required
            className="w-full p-3 rounded-lg bg-[#E6E9F0]"
          />

          {/* Story */}
          <textarea
            name="story"
            value={form.story}
            onChange={handleChange}
            placeholder="Briefly describe your diagnosis, exposure, or situation"
            className="w-full p-3 rounded-lg bg-[#E6E9F0]"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#DBE2EF] py-3 rounded-lg font-semibold"
          >
            {loading ? "Submitting..." : "Start My Free Case Review"}
          </button>

          {message && (
            <p className="text-center text-sm mt-2">{message}</p>
          )}
        </form>
      </div>
    </div>
  );
};

export default HomeForm;
